/**
 * Created by ez on 2019/12/26
 */
const pwaConfig = [
  {
    product: 'A04',
    openApp: 'com.zlong://',
    displayName: '',
    displayIcon: ''
  }, {
    product: 'A02',
    openApp: 'KFAmuse://',
    displayName: '凯发娱乐',
    displayIcon: ''
  }
]
export default pwaConfig



// WEBPACK FOOTER //
// ./src/api/pwaConfig.js